import React from 'react';
import { Breadcrumbs, Button, IconButton, InputBase, Paper, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search, Upload, Add, FilterList } from '@mui/icons-material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import styles from './informationHeader.module.css';
import { useNavigate } from 'react-router-dom';


const ActionButton = styled(Button)(({ theme }) => ({
  padding: '6px 18px 6px 18px',
  borderRadius: '8px',
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#1D1F2C',
  backgroundColor: 'transparent',
  border: '1px solid #C2C6CE',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AddCategoryButton = styled(Button)(({ theme }) => ({
  padding: '6px 18px 6px 18px',
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: '0.875rem',
  backgroundColor: '#512DA8',
  opacity: '0.65',
  color: '#fff',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const InformationHeader = ({ prevpage, mainpage, pagename, buttonText, }) => {
  const navigate = useNavigate()
  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}
        sx={{ paddingBottom: '30px' }}>
        {/* Breadcrumbs and Title */}
        <Stack spacing={1}>
          <Typography variant="h5" fontWeight="bold" sx={{
            fontSize: '24px',
            fontWeight: '600',
            textAlign: 'left',
            color: '#1D1F2C',
            fontFamily: `'Public Sans', sans-serif`,
          }}>
            {pagename}
          </Typography>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <Typography color="text.secondary"
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                letterSpacing: '0.005em',
                textAlign: 'left',
                color: '#1D1F2C',
                fontFamily: `'Public Sans', sans-serif`,
              }}
            >{mainpage}</Typography>

            <Typography color="text.primary"
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                letterSpacing: '0.005em',
                textAlign: 'left',
                color: '#1D1F2C',
                fontFamily: `'Public Sans', sans-serif`,
              }}>{prevpage}</Typography>

            <Typography color="text.primary"
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                letterSpacing: '0.005em',
                textAlign: 'left',
                color: '#667085',
                fontFamily: `'Public Sans', sans-serif`,
              }}>{pagename}</Typography>
          </Breadcrumbs>
        </Stack>

        {/* Search and Action Buttons */}
        <Stack direction="row" alignItems="center" spacing={2}>
          <ActionButton onClick={() => navigate(-1)}>Back to list</ActionButton>
          {/* <AddCategoryButton>{buttonText}</AddCategoryButton> */}
        </Stack>
      </Stack >

     

    </>
  );
};

export default InformationHeader;
